import CarrierLookupCard from "@/components/CarrierLookupCard";

export default function AdminCarrierLookup() {
  return (
    <div className="space-y-6" data-testid="admin-carrier-lookup-page">
      <div>
        <div className="hs-overline text-blue-700">CRYSTAL LOGISTICS · CARRIER INTELLIGENCE</div>
        <h1 className="font-display font-black text-4xl uppercase tracking-tighter mt-2">
          Carrier Lookup
        </h1>
        <p className="text-sm text-slate-500 mt-2 max-w-2xl">
          Enter any DOT or MC number to pull the official FMCSA Carrier Snapshot, the 7 CSA
          BASIC percentile scores, and generate a branded Crystal Logistics AI compliance
          review you can hand to a prospect or customer.
        </p>
      </div>

      <CarrierLookupCard />
    </div>
  );
}
